import {
  Text,
  Box,
  Textarea,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';
import {
  IconAlertCircle,
} from '../../../../../styles/icons';
import {
  profileAccordionButton,
  profileAccordionPanel,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import {useCallback, useState} from 'react';
import { useDispatch } from 'react-redux';
import {updateProfileValue} from "../../../../redux/actions/user";

const EditSectionQualifications = ({ profile }) => {
  const [qualification, setQualification] = useState(profile.qualifications[0]);

  const dispatch = useDispatch();

  const handleProfileValueUpdate = useCallback((e) => {
    setQualification(e.target.value);
    dispatch(updateProfileValue('qualifications', [e.target.value]))
  }, [dispatch]);

  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            //width="100%"
            textAlign="left"
          >
            <Box>
              <Text>Training & qualifications</Text>
              {profile.qualifications[0]?.length > 0 && (
                <Text textStyle="footer2" color="brand.200">
                  {profile.qualifications[0]}
                </Text>
              )}
            </Box>
            {profile.qualifications[0]?.length > 0 ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Please indicate your training
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className='w-full'>
            <Textarea
              bg="brand.100"
              width="100%"
              height="300px"
              name="aboutMe"
              value={qualification}
              placeholder="Use this space to mention any qualifications that you have which support your practice and your areas of expertise or interest."
              onChange={handleProfileValueUpdate}
            />
          </div>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionQualifications;
